// extracted by mini-css-extract-plugin
var _1 = "learningPath-module_closeIcon_PyxF8";
var _2 = "learningPath-module_learningPathButtonElement_TlXgW";
var _3 = "learningPath-module_learningPathButtonWrapper_aanH1";
var _4 = "learningPath-module_learningPathHeaderWrapper_va6FO";
var _5 = "learningPath-module_learningPathInputWrapper_MiWCU";
var _6 = "learningPath-module_learningPathMainWrapper_yR5eb";
var _7 = "learningPath-module_learningPathWrapper_AJKls";
export { _1 as "closeIcon", _2 as "learningPathButtonElement", _3 as "learningPathButtonWrapper", _4 as "learningPathHeaderWrapper", _5 as "learningPathInputWrapper", _6 as "learningPathMainWrapper", _7 as "learningPathWrapper" }
